import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-controls"]
const _hoisted_2 = ["id", "aria-labelledby"]
const _hoisted_3 = { class: "ds-accordion-item__body-content" }

import DsIcon from "../icon/ds-icon.vue";
import type { SvgIcons } from "../icon/types";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-accordion-item',
  props: {
    defaultOpen: { type: Boolean },
    itemId: { default: 0 },
    headerIconName: { default: "arrow-down" },
    isInStorybook: { type: Boolean }
  },
  emits: ["expanded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isOpen = ref(props.defaultOpen);
const emit = __emit;

const handleToggle = () => {
    isOpen.value = !isOpen.value;
    if (isOpen.value) emit("expanded");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ds-accordion-item", { 'is-open': _ctx.defaultOpen }]),
    onClick: handleToggle
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "ds-accordion-item__header",
      "aria-expanded": "false",
      id: `ds-accordion-item-${_ctx.itemId}`,
      "aria-controls": `ds-accordion-item-content-${_ctx.itemId}`
    }, [
      _renderSlot(_ctx.$slots, "summary"),
      _createVNode(DsIcon, {
        width: 24,
        height: 24,
        name: _ctx.headerIconName,
        "is-in-storybook": _ctx.isInStorybook,
        class: "ds-accordion-item__header-icon"
      }, null, 8, ["name", "is-in-storybook"])
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: `ds-accordion-item-content-${_ctx.itemId}`,
      class: "ds-accordion-item__body",
      role: "region",
      "aria-labelledby": `ds-accordion-item-${_ctx.itemId}`
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "ds-accordion-item__body-divider" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "text")
      ])
    ], 8, _hoisted_2)
  ], 2))
}
}

})